module.exports = __webpack_public_path__ + "media/packs/booking-system/appointment-booking/src/images/booking_confirm-901cc3217e065af9b08e8f141db9401f.jpg";